import React, { FC } from 'react';
import { Typography, Box, ChartLegend } from '@scope/scope-one-ui/core';
import { COLORS } from '@scope/scope-one-ui/theme';
import { ScatterChart } from '@scope/scope-one-ui/core/Charts/ScatterChart/ScatterChart';
import { useTranslation } from 'react-i18next';
import { CHARTS_COLORS } from '@scope/scope-one-ui/theme/charts';
import { VerticalTitle, HorizontalTitles, ChartContainer } from './PeerGroupComparison.styled';
import { AttentionBuzzData } from './AttentionBuzzChart.d';
import { chartDataParser } from './parsers';

export const AttentionBuzzChart: FC<AttentionBuzzData> = ({ chartData }) => {
  const { t } = useTranslation();

  const parsedData = chartDataParser(chartData, CHARTS_COLORS);
  const companyName = chartData.actualCompany[0]?.companyName || 'Company';

  const legend = [
    {
      label: companyName,
      color: CHARTS_COLORS[0],
    },
    {
      label: 'Peers',
      color: CHARTS_COLORS[1],
    },
    {
      label: 'Industries',
      color: CHARTS_COLORS[2],
    },
    {
      label: 'Sectors',
      color: CHARTS_COLORS[3],
    },
  ];

  return (
    <ChartContainer mt={1}>
      <VerticalTitle display="flex" justifyContent="center" color={COLORS.typography.main}>
        <Typography variant="body1" color={COLORS.typography.main}>
          {t('High Attention buzz')}
        </Typography>
      </VerticalTitle>
      <HorizontalTitles
        display="flex"
        justifyContent="space-between"
        color={COLORS.typography.main}
      >
        <Box>
          <Typography variant="body1">{t('Negative')}</Typography>
          <Typography variant="body1">{t('Sentiment')}</Typography>
        </Box>
        <Box>
          <Typography variant="body1" color={COLORS.typography.main}>
            {t('Positive')}
          </Typography>
          <Typography variant="body1" color={COLORS.typography.main}>
            {t('Sentiment')}
          </Typography>
        </Box>
      </HorizontalTitles>
      <ScatterChart
        data={parsedData}
        horizontalMiddleLine={{
          chartHeight: 58,
        }}
        verticalMiddleLine={{
          chartWidth: 58,
        }}
        hideXAxis
        hideYAxis
        xAxisRange={[-10, 10]}
        yAxisRange={[-250, 250]}
        tooltipLabels={{
          labelX: 'ESG Sentiment Score:',
          labelY: 'Attention Buzz:',
          labelYUnit: '%',
        }}
      />
      <VerticalTitle display="flex" justifyContent="center">
        <Typography variant="body1" color={COLORS.typography.main}>
          {t('Low Attention buzz')}
        </Typography>
      </VerticalTitle>
      <Box display="flex" justifyContent="center">
        <ChartLegend items={legend} size="semiMedium" />
      </Box>
    </ChartContainer>
  );
};
